// Image section & assets
const imgContainer = document.querySelector(".ring-container_image");
const ringContent = document.querySelector(".ring-container_content");

  // Preload images
  function preloadImages(images) {
    const imageObjects = [];

    for (let i in images) {
      const img = new Image();
      img.src = images[i];
      imageObjects.push(img);
    }

    return imageObjects;
  }

	const ringImages = {
		1: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0041_ring__01681.jpg",
		2: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0040_ring__01662.jpg",
		3: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0039_ring__01641.jpg",
		4: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0038_ring__01628.jpg",
		5: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0037_ring__01623.jpg",
		6: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0036_ring__01619.jpg",
		7: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0035_ring__01613.jpg",
		8: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0034_ring__01603.jpg",
		9: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0033_ring__01581.jpg",
		10: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0032_ring__01562.jpg",
		11: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0031_ring__01543.jpg",
		12: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0030_ring__01520.jpg",
		13: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0029_ring__01503.jpg",
		14: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0028_ring__01482.jpg",
		15: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0027_ring__01479.jpg",
		16: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0026_ring__01462.jpg",
		17: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0025_ring__01450.jpg",
		18: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0024_ring__01440.jpg",
		19: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0023_ring__01432.jpg",
		20: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0022_ring__01423.jpg",
		21: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0021_ring__01401.jpg",
		22: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0020_ring__01376.jpg",
		23: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0019_ring__01361.jpg",
		24: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0018_ring__01342.jpg",
		25: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0017_ring__01330.jpg",
		26: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0016_ring__01322.jpg",
		27: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0015_ring__01302.jpg",
		28: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0014_ring__01280.jpg",
		29: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0013_ring__01260.jpg",
		30: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0012_ring__01242.jpg",
		31: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0011_ring__01221.jpg",
		32: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0010_ring__01203.jpg",
		33: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0009_ring__01182.jpg",
		34: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0008_ring__01163.jpg",
		35: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0007_ring__01142.jpg",
		36: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0006_ring__01122.jpg",
		37: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0005_ring__01102.jpg",
		38: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0004_ring__01079.jpg",
		39: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0003_ring__01060.jpg",
		40: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0002_ring__01040.jpg",
		41: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0001_ring__01020.jpg",
		42: "https://cdn.shopify.com/s/files/1/0531/8230/0329/files/CLIQ-Ring-Main-Frame_0000_ring__01002.jpg"
	};
	const preloadedImages = preloadImages(ringImages);

// Global variable to control the scrolling behavior
const step = 12; // For each XXpx, change an image

function trackScrollPosition() {
  let y = window.scrollY;
  let label = Math.min(Math.floor(y / step) + 1, 42);

  if (label >= 42) {
	imgContainer.src = ringImages[42];
	// ringContent.style.opacity = 0;
  } else {
	imgContainer.src = ringImages[label];
	// ringContent.style.opacity = 1;
  }
}

function allImagesLoaded() {
  return Object.values(ringImages).every((url) => {
	const img = new Image();
	img.src = url;
	return img.complete;
  });
}

function startAnimation() {
  if (allImagesLoaded()) {
	window.addEventListener("scroll", trackScrollPosition);
  } else {
	setTimeout(startAnimation, 100);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  startAnimation();
});